import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './aboutus.css'

const Aboutus = (props) => {
  return (
    <div id={props.aboutUsId1} className="thq-section-padding scroll-target">
      <div className="aboutus-thq-max-width-elm thq-section-max-width">
        <div className="aboutus-thq-content-elm thq-flex-column">
          <ul className="aboutus-ul thq-flex-column">
            <li className="thq-flex-column list-item">
              <h2 className="aboutus-thq-heading1-elm thq-heading-2">
                {props.heading1 ?? (
                  <Fragment>
                    <span className="aboutus-text16">About Evac</span>
                  </Fragment>
                )}
              </h2>
              <p className="thq-body-small">
                {props.content1 ?? (
                  <Fragment>
                    <span className="aboutus-text14">
                      Evac is a professional towing service provider offering
                      reliable and efficient assistance 24/7 for vehicles of all
                      sizes. With a courteous team that provides quick emergency
                      response times, we ensure prompt service to all our
                      customers.
                    </span>
                  </Fragment>
                )}
              </p>
            </li>
            <li className="list-item">
              <h3 className="thq-heading-3">
                {props.heading2 ?? (
                  <Fragment>
                    <span className="aboutus-text18">Our Services</span>
                  </Fragment>
                )}
              </h3>
              <p className="thq-body-small">
                {props.content2 ?? (
                  <Fragment>
                    <span className="aboutus-text17">
                      We offer towing services for vehicles of all sizes,
                      including cars, trucks, and motorcycles. Our team is
                      equipped to handle emergency situations and provide timely
                      assistance whenever you need it.
                    </span>
                  </Fragment>
                )}
              </p>
            </li>
            <li className="list-item">
              <h3 className="thq-heading-3">
                {props.heading3 ?? (
                  <Fragment>
                    <span className="aboutus-text11">
                      Customer Testimonials
                    </span>
                  </Fragment>
                )}
              </h3>
              <p className="thq-body-small">
                {props.content3 ?? (
                  <Fragment>
                    <span className="aboutus-text19">
                      Read what our satisfied customers have to say about our
                      prompt service and efficient assistance. We take pride in
                      delivering high-quality towing services that exceed
                      expectations.
                    </span>
                  </Fragment>
                )}
              </p>
            </li>
            <li className="list-item">
              <h3 className="thq-heading-3">
                {props.heading4 ?? (
                  <Fragment>
                    <span className="aboutus-text13">Gallery</span>
                  </Fragment>
                )}
              </h3>
              <p className="thq-body-small">
                {props.content4 ?? (
                  <Fragment>
                    <span className="aboutus-text10">
                      Explore our gallery showcasing our team in action,
                      assisting vehicles of all sizes. See firsthand the
                      dedication and professionalism we bring to every towing
                      job.
                    </span>
                  </Fragment>
                )}
              </p>
            </li>
            <li className="list-item">
              <h3 className="thq-heading-3">
                {props.heading5 ?? (
                  <Fragment>
                    <span className="aboutus-text12">Contact Us</span>
                  </Fragment>
                )}
              </h3>
              <p className="thq-body-small">
                {props.content5 ?? (
                  <Fragment>
                    <span className="aboutus-text15">
                      For reliable and efficient towing services 24/7, contact
                      Evac today. Our team is ready to assist you with any
                      towing needs you may have.
                    </span>
                  </Fragment>
                )}
              </p>
            </li>
            <li className="list-item"></li>
          </ul>
        </div>
      </div>
    </div>
  )
}

Aboutus.defaultProps = {
  content4: undefined,
  heading3: undefined,
  heading5: undefined,
  heading4: undefined,
  content1: undefined,
  aboutUsId1: '',
  rootClassName: '',
  content5: undefined,
  heading1: undefined,
  content2: undefined,
  heading2: undefined,
  content3: undefined,
}

Aboutus.propTypes = {
  content4: PropTypes.element,
  heading3: PropTypes.element,
  heading5: PropTypes.element,
  heading4: PropTypes.element,
  content1: PropTypes.element,
  aboutUsId1: PropTypes.string,
  rootClassName: PropTypes.string,
  content5: PropTypes.element,
  heading1: PropTypes.element,
  content2: PropTypes.element,
  heading2: PropTypes.element,
  content3: PropTypes.element,
}

export default Aboutus
